export const useTools = () => {

  const formatEUR = (number) => {
    return new Intl.NumberFormat('es-ES', { style: 'currency', currency: 'EUR', minimumFractionDigits: 0, useGrouping: true }).format(number)
  }

  function formatDateUNIX(UNIX_timestamp){
    var a = new Date(UNIX_timestamp * 1000);
    // var months = ['Ene','Feb','Mar','Abr','May','Jun','Jul','Ago','Sep','Oct','Nov','Dic'];
    var months = ['01','02','03','04','05','06','07','08','09','10','11','12'];
    var year = a.getFullYear();
    var month = months[a.getMonth()];
    var date = a.getDate();
    var time = date + '/' + month + '/' + year;
    return time;
  }

  function formatDate(timestamp){
    let a = new Date(timestamp);
    if(!timestamp?.toString().split("T")[1]){ a = new Date([timestamp, '00:00']) }
    // var months = ['Ene','Feb','Mar','Abr','May','Jun','Jul','Ago','Sep','Oct','Nov','Dic'];
    var months = ['01','02','03','04','05','06','07','08','09','10','11','12'];
    var year = a.getFullYear();
    var month = (months[a.getMonth()] || 'NaM');
    var date = a.getDate();
    var time = date + '/' + month + '/' + year;
    return time;
  }

  function formatMonthDay(timestamp){
    let a = new Date(timestamp);
    if(!timestamp?.toString().split("T")[1]){ a = new Date([timestamp, '00:00']) }
    // var months = ['Ene','Feb','Mar','Abr','May','Jun','Jul','Ago','Sep','Oct','Nov','Dic'];
    var months = ['01','02','03','04','05','06','07','08','09','10','11','12'];
    var year = a.getFullYear();
    var month = (months[a.getMonth()] || 'NaM');
    var date = a.getDate();
    var time = date + '/' + month;
    return time;
  }

  const printSection = (e, idSection) =>{
    e.preventDefault()
    const prtContent = document.getElementById(idSection);
    const WinPrint = window.open('', '', 'left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0');
    WinPrint.document.write(prtContent.innerHTML);
    WinPrint.document.close();
    WinPrint.focus();
    WinPrint.print();
    WinPrint.close();
    // return section;
  }

  return {
    formatEUR,
    formatDate,
    formatMonthDay,
    formatDateUNIX,
    printSection
  }
}